import { useNavigate } from "react-router-dom";

export const useNextNavigation = (page: number, questionSet: any) => {
    const navigate = useNavigate();

    navigate(`/${page}`, { state: { questions: { questionSet } } });
};